<template>
	<recent-companies :take="take" :per-page="perPage" :filters="{ keys: computeFilters }"></recent-companies>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import recentCompanies from "@/components/webComponents/widget/recentCompanies/recentCompanies.vue";
	export default {
		components: {
			recentCompanies
		},
		props: {
			json: {
				type: String,
				default: undefined
			},
			take: {
				type: [String, Number],
				default: 5
			},
			pageFilters: {
				type: String,
				default: "{}"
			},
			perPage: {
				type: Number,
				default: 50
			}
		},
		setup(props, context) {
			const $json = inject("$json");
			const moment = inject("$moment");
			const $http = inject("$http");

			const globalFilters = ref({});
			const filter = ref([]);

			if ($json.packed(props.json)) {
				filter.value = JSON.parse($json.unpack(props.json));
			} else {
				filter.value = JSON.parse(props.json || "[]");
			}

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			const computeFilters = computed(() => {
				if (filter.value.length > 0) {
					return filter.value;
				} else if (globalFilters.value.CompaniesFilter.length > 0) {
					return globalFilters.value.CompaniesFilter;
				} else {
					return globalFilters.value.Parent?.CompaniesFilter || [];
				}
			});

			return {
				computeFilters
			};
		}
	};
</script>
